// libs
import React, { memo, useRef } from 'react';
import get from 'lodash/get';
import { styled } from '@nykaa/ui-components';

// components
import Image from 'shared/components/Image';

// helpers
import { generateSameHostUrl, getOptimisedImageUrl } from 'shared/helpers/utils';

// hooks
import { useTrackingObserver } from 'shared/components/AdPlatformWidgets/ImpressionTracking/trackingHooks';
import { useDwebOnClick } from 'shared/components/AdPlatformWidgets/Desktop/hooks';

const CAROUSEL_ALT_LABEL = 'Banner Image';

// Hack - as carousel component keeps certain portion of a slide across carousels
// TODO - Fix carousel and remove carousel node
const CarouselNode = styled.div`
  position: absolute;
  left: 5px;
  top: 5px;
  height: 1px;
  width: 1px;
`;

const Anchor = styled.a`
  display: block;
  position: relative;
`;

const Section = styled.div`
  position: relative;
`;

interface IImageCarouselProps {
  slideWidth: number;
  deviceWidth: number;
  key: number;
  slideHeight: number;
  img: object;
}

function ImageCarousel({ slideWidth, deviceWidth, key, slideHeight, img }: IImageCarouselProps) {
  const widgetRef = useRef<HTMLDivElement>(null);
  const trackingData = get(img, 'trackingData');
  const actionUrl = get(img, 'action_url');
  const imageUrl = get(img, 'url');

  const url = actionUrl ? generateSameHostUrl(actionUrl) : undefined;

  const { onWidgetClick } = useTrackingObserver({ widgetRef, trackingData });
  const { onClick } = useDwebOnClick({ url, onWidgetClick, trackingData });

  return actionUrl ? (
    <Anchor href={url} onClick={onClick} key={key} target="_blank" aria-label={CAROUSEL_ALT_LABEL}>
      <CarouselNode ref={widgetRef} />
      <Image
        src={getOptimisedImageUrl(imageUrl, { width: deviceWidth * 2 })}
        width={slideWidth}
        animate
        height={slideHeight}
        key={key}
        alt={CAROUSEL_ALT_LABEL}
      />
    </Anchor>
  ) : (
    <Section>
      <CarouselNode ref={widgetRef} />
      <Image
        src={getOptimisedImageUrl(imageUrl, { width: deviceWidth * 2 })}
        width={slideWidth}
        animate
        height={slideHeight}
        key={key}
        alt={CAROUSEL_ALT_LABEL}
      />
    </Section>
  );
}

export default memo(ImageCarousel);
